import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: colors.grey.darken1,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.blue,
    warning: colors.orange
  },
  dark: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.orange
  }
}

export default {
  dark: false,
  options: {
    customProperties: true,
    breadcrumbs: {
      color: 'grey'
    },
    grid: {
      pageSize: [5, 10, 20, 50, 100]
    }
  },
  themes: themes
}
